import type { BillingAddress, Qiao } from '.';

let _supportsChinaUnionPayForApplePayWeb = false;

const qiao: Qiao = {
  tokenizeCreditCardToStripe(
    _clientToken: string,
    _card: {
      card: string;
      exp: string;
      cvv: string;
      billingAddress: BillingAddress;
    },
  ): Promise<string> {
    throw new Error('Not implemented');
  },
  async supportsChinaUnionPay() {
    return _supportsChinaUnionPayForApplePayWeb;
  },
  async enableChinaUnionPay() {
    _supportsChinaUnionPayForApplePayWeb = true;
    return true;
  },
  async disableChinaUnionPay() {
    _supportsChinaUnionPayForApplePayWeb = false;
    return false;
  },
};

export const qiaoEvent = null;

export default qiao;
